import SuccessMeasure from './SuccessMeasure';

export default SuccessMeasure;
